import { useEffect } from 'react'

import { usePathname, useSearchParams } from 'next/navigation'

import { useGA } from './useGA'

export const useChangePageView = () => {
  const { sendPageView } = useGA()

  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!process.env.GoogleAnalyticsId) {
      return
    }
    const url = pathname + searchParams.toString()
    sendPageView(url)
  }, [pathname, searchParams, sendPageView])
}
